import { Col, Form, Row } from "antd";
import { HeaderOverview } from "components";
import { PROPERTY_MENUS } from "menus/property";
import { useOverview } from "providers/overview";
import React from "react";
import { useTranslation } from "react-i18next";
import { dataMenuCode } from "service/dashboard/central/survey/interface";
import { useGetPropertyDashboardSurvey } from "service/dashboard/property/survey";
import styled from "styled-components";
import tw from "twin.macro";
import { ErrorDashboard, LoadingDashboard, Wrapper } from "..";
import ItemSurvey from "./item";

export interface IMenuItem {
  key: string;
  title: string;
  icon?: React.ComponentType;
  code: string;
  slug?: string;
  score: number;
  countResponsibility?: number;
}

const Survey = () => {
  const { t } = useTranslation();
  const { findDate } = useOverview();

  const surveyDate = Form.useWatch("surveyDate");
  const date = findDate(surveyDate);

  const { data, isFetching, isError, error } = useGetPropertyDashboardSurvey({
    ...date,
  });

  const WrapperItem = styled.div`
  ${tw`bg-white rounded-app p-5 w-full h-[200px]`}
`;

  const propertyMenu = () => {
    if (!data) {
      const menus = PROPERTY_MENUS.map((menu) => ({ ...menu, score: 0 }));
      return { menus, avgScore: 0 };
    }

    const filterMenu = PROPERTY_MENUS.filter((e) =>
      dataMenuCode.some((m) => m === e.code)
    );

    const menus = filterMenu.map((menu: any) => {
      const findData = data.find((entry) => entry.code === menu.code);
      return {
        ...menu,
        score: findData ? Math.round(findData.score) : 0,
        title: t(menu.title, { ns: "menu" }),
        countResponsibility:findData?findData.countResponsibility :0
      };
    });

    return { menus };
  };

  const { menus } = propertyMenu();

  return (
    <Wrapper>
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("property.survey", { ns: "menu" })}
          name="surveyDate"
        />
        <Row gutter={[14, 14]} className="h-[420px] overflow-auto">
          {isError ? (
            <ErrorDashboard error={error} />
          ) : (
            menus.map((item: any) => {
              return (
                <Col key={item.title} sm={24} md={12} lg={8} xl={8} xxl={6}>
                  <ItemSurvey item={item} />
                </Col>
              );
            })
          )}
        </Row>
      </LoadingDashboard>
    </Wrapper>
  );
};

export default Survey;
